<template>
    <div class="my-2 py-2">
        <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-btn class="white--text" round color="primary" @click="addVirtualPackageModal()">Add Package</v-btn>
        </v-toolbar>
        <v-data-table :items="virtualFnoPackages" :headers="headers" min-width="1000px"
         :rows-per-page-items="[25, 50, 100, 250]"
         :key="key"
      item-key="name"
      align-center
      style="cursor: pointer"
      disable-initial-sort
    >
      <template v-slot:items="props">
          <td class="text-xs-center">
             <v-layout justify-center>
                 <v-icon color="grey" @click="editVirtualPackageModal(props.item)">edit</v-icon>
                 <v-icon color="grey" @click="deleteVirtualPackageModal(props.item)">delete</v-icon>
             </v-layout>
          </td>
          <td class="text-xs-center">
              {{props.item.name}}
          </td>
          <td class="text-xs-center">
              {{props.item.type}}
          </td>
          <td class="text-xs-center">
              {{props.item.price | currency}}
          </td>
          <td class="text-xs-center">
            <v-chip color="light-green" class="white--text" v-if="props.item.isActive" @click="updateStatus(props.item)">Active</v-chip>
            <v-chip color="red" class="white--text" v-else @click="updateStatus(props.item)">Inactive</v-chip>
          </td>
      </template>

        </v-data-table>
        <v-dialog v-model="addPackageModal" width="750px" persistent>
            <v-card>
                <v-toolbar flat color="primary" >
                    <h3 class="title white--text">{{item.modalType}} Package</h3>
                    <v-spacer></v-spacer>
                    <v-btn flat color="white" @click="addPackageModal=false, item={}">X</v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-layout justify-center wrap>
                        <v-flex xs4 mx-1>
                            <v-text-field label="Package Name" v-model="item.name"></v-text-field>
                        </v-flex>
                        <v-flex xs4 mx-1>
                            <v-select label="Type" v-model="item.type" :items="packageTypes"></v-select>
                        </v-flex>
                        <v-flex xs4 mx-1>
                            <v-autocomplete label="Speed Profile" v-model="item.speedProfileId" item-text="name" item-value="id" :items="speedProfiles"></v-autocomplete>
                        </v-flex>
                        <v-flex xs4 mx-1>
                            <v-text-field type="number" step="0.01" label="Monthly Price (excl. VAT)" v-model="item.price"></v-text-field>
                        </v-flex>
                        <v-flex xs4 mx-1>
                            <v-text-field type="number" step="0.01" label="Setup Fee (excl. VAT)" v-model="item.setupFee"></v-text-field>
                        </v-flex>

                    </v-layout>
                    <v-card-actions>
                        <v-layout justify-center>
                            <v-btn v-if="item.modalType=='Add'" round color="primary" @click="createVirtualPackages(item)">Create</v-btn>
                            <v-btn v-else-if="item.modalType=='Edit'" round color="primary" @click="updateVirtualPackages(item)">Save</v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import Api from '../services/Api'
export default {
    data(){
        return {
            addPackageModal: false,
            packageTypes: ['Residential', 'Business'],
            item: {},
            key: 0,
            speedProfiles: [],
            virtualFnoPackages: [],
            headers: [
                {
          text: "Action",
          align: "center"
        },
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        {
          text: "Type",
          align: "center",
          value: "type"
        },
        {
          text: "Price (excl. VAT)",
          align: "center",
          value: "price"
        },
        {
          text: "Status",
          align: "center",
          value: "isActive"
        }
            ]
        }
    },
    created(){
        this.initialize()
    },
    methods: {
        initialize(){
            this.getVirtualPackages()
            this.getSpeedProfiles()
        },
        getSpeedProfiles(){
            Api().get('/speedProfiles/active')
            .then(response=>{
                this.speedProfiles = response.data
                console.log(this.speedProfiles)
            })
        },
        updateStatus(item){
            Api().put('/virtualFnoPackage/'+item.id, {isActive: !item.isActive})
            .then(async response=>{
                let find = await this.virtualFnoPackages.find(x=>x.id == item.id)
                let index = await this.virtualFnoPackages.indexOf(find)
                this.virtualFnoPackages[index].isActive = response.data.isActive
                this.key += 1
            })
        },
        getVirtualPackages(){
            Api().get('/virtualFnoPackage')
            .then(response=>{
                this.virtualFnoPackages=response.data
            })
        },
        addVirtualPackageModal(){
            if(this.authUpdate(this.$store.state.currentRoute)){
            this.item={
                modalType: 'Add',
                isGloabal: true
            }
            this.addPackageModal=true
            }
        },
        editVirtualPackageModal(item){
            if(this.authUpdate(this.$store.state.currentRoute)){
                 this.item={
                modalType: 'Edit',
                id: item.id,
                name: item.name,
                type: item.type,
                price: item.price,
                speedProfileId: item.speedProfileId
            }
            this.addPackageModal=true
            }
           
        },
        deleteVirtualPackageModal(item){
            if(this.authDelete(this.$store.state.currentRoute)){
            confirm("Are you sure you want to delete this package?")&&
            Api().put('/virtualFnoPackage/'+item.id, {isActive: false, isDeleted: true})
            .then(response=>{
                let find = this.virtualFnoPackages.find(x=>x.id == item.id)
                let index = this.virtualFnoPackages.indexOf(find)
                this.virtualFnoPackages.splice(index, 1)
                this.key += 1
            })
            }
        },
        updateVirtualPackages(item){
            Api().put('/virtualFnoPackage/'+item.id, item)
            .then(async response=>{
                let find = await this.virtualFnoPackages.find(x=>x.id == item.id)
                let index = await this.virtualFnoPackages.indexOf(find)
                this.virtualFnoPackages[index] = response.data
                this.item = {}
                this.addPackageModal=false
                this.key += 1
            })
        },
        createVirtualPackages(item){
            Api().post('/virtualFnoPackage', item)
            .then(response=>{
                this.virtualFnoPackages.push(response.data)
                this.item = {}
                this.addPackageModal=false
                this.key += 1
            })
        }
    }
}
</script>